$(function () {
    $('._js-radio-link').on('click', function () {
        var tabID = $(this).attr('data-target');
        $(this).siblings().removeClass('_active'); // Remove the ._active class from sibling tab navigation elements.
        $(tabID).addClass('_active'); // Add the ._active class to the div with the tab content.
        $(tabID).siblings().removeClass('_active'); // Remove the ._active class from other tab content divs.
    });
});